// =========================================
// ASTROLOGY TIMES — SITE CONFIGURATION
// Edit this file to customize your website
// =========================================

export const SITE_CONFIG = {
  // ← CHANGE: Your brand name
  brandName: "Astrology Times",
  brandNameHi: "एस्ट्रोलॉजी टाइम्स",

  // ← CHANGE: Your WhatsApp business numbers (include country code, no + sign)
  whatsappNumber1: "918099975662",
  whatsappNumber2: "919440698250",

  // ← CHANGE: Astrologer name
  astrologerName: "Surendra Kumar Patawari",
  astrologerNameHi: "सुरेंद्र कुमार पटवारी",

  // ← CHANGE: Your business email
  contactEmail: "astrologytimes5@gmail.com",

  // ← CHANGE: Your phone numbers displayed on site
  displayPhone1: "8099975662",
  displayPhone2: "9440698250",

  // ← CHANGE: Years of experience (shown in stats)
  yearsExperience: "17+",

  // ← CHANGE: Happy clients count
  happyClients: "5000+",

  // ← CHANGE: Rating
  rating: "4.9/5",

  // ← CHANGE: Domain
  domain: "astrologytimes.co.in",

  // ← CHANGE: Logo URL
  logoUrl: "/images/Logo.png",

  // ← CHANGE: Location
  location: "Hyderabad, Telangana, India",

  // Astrology package prices (in INR)
  // ← CHANGE any price below
  prices: {
    astrology: {
      basic: { name: "Basic Reading", nameHi: "बेसिक रीडिंग", duration: 30, price: 1500 },
      standard: { name: "Standard Reading", nameHi: "स्टैंडर्ड रीडिंग", duration: 60, price: 2500 },
      marriage: { name: "Marriage Consultation", nameHi: "विवाह परामर्श", duration: 45, price: 2000 },
      career: { name: "Career & Business", nameHi: "करियर और व्यवसाय", duration: 45, price: 2000 },
      dasha: { name: "Dasha & Remedies", nameHi: "दशा और उपाय", duration: 60, price: 3000 },
    },
    vastu: {
      basic_report: { name: "Basic Vastu Report", nameHi: "बेसिक वास्तु रिपोर्ट", price: 7000, desc: "Upload floor plan, get PDF report in 48 hours", descHi: "फ्लोर प्लान अपलोड करें, 48 घंटे में PDF रिपोर्ट" },
      home_video: { name: "Home Vastu Video Call", nameHi: "होम वास्तु वीडियो कॉल", price: 9000, desc: "Comprehensive home vastu analysis", descHi: "व्यापक होम वास्तु विश्लेषण" },
      office_video: { name: "Office/Shop Vastu Video Call", nameHi: "ऑफिस/शॉप वास्तु", price: 11000, desc: "Complete office/shop vastu consultation", descHi: "पूर्ण ऑफिस/शॉप वास्तु परामर्श" },
      factory_video: { name: "Factory/Industrial Vastu", nameHi: "फैक्ट्री/इंडस्ट्रियल वास्तु", price: 15000, desc: "Large-scale industrial vastu guidance", descHi: "औद्योगिक वास्तु मार्गदर्शन" },
    },
    perMinuteRate: 60,  // ← CHANGE: Per-minute rate in INR
  },

  // ← CHANGE: Max bookings per day (admin can override per date)
  maxBookingsPerDay: 3,

  // ← CHANGE: First time free discount in rupees (10 min × ₹60/min = ₹600)
  firstTimeFreeDiscount: 600,

  // ← CHANGE: Referral amounts
  referralDiscount: 200,    // Discount for referred user
  referralCredit: 300,      // Credit for referrer

  // ← CHANGE: Loyalty points config
  loyaltyPointsPerRupee: 100,  // Spend ₹100 = 1 point
  loyaltyRedeemRate: 100,      // 100 points = ₹100 discount

  // Working hours
  workingHours: {
    weekday: "11am - 1pm, 3pm - 7pm",
    sunday: "11am - 3pm",
  },

  // EmailJS credentials
  // ← CHANGE: Your EmailJS credentials
  emailjs: {
    serviceId: "service_kdzpah6",
    templateId: "template_lxs7d4d",
    publicKey: "xDVA5SqO_I89rUM3v",
  },

  // SEO Configuration — Edit titles and descriptions for each page
  // ← CHANGE: Update these for better Google rankings
  seo: {
    home: {
      title: "Astrology Times | Vedic Astrology & Vastu Consultation | Surendra Kumar Patawari",
      description: "Book online astrology and Vastu consultation with certified Vedic astrologer Surendra Kumar Patawari. 17+ years experience. Hindi & English. First 10 min FREE.",
    },
    astrology: {
      title: "Astrology Services | Kundli Reading, Marriage & Career Consultation | Astrology Times",
      description: "Professional Vedic astrology consultations — basic reading, marriage, career, dasha analysis. Book online with Razorpay. Hindi & English available.",
    },
    vastu: {
      title: "Vastu Services | Home, Office & Factory Vastu Consultation | Astrology Times",
      description: "Expert Vastu Shastra consultation for homes, offices, factories. Online video calls and on-site visits available across India.",
    },
    booking: {
      title: "Book Consultation | Astrology Times",
      description: "Book your astrology or Vastu consultation. Select service, provide birth details, choose date & time, pay securely via Razorpay.",
    },
    horoscope: {
      title: "Daily Horoscope (Rashifal) | 12 Zodiac Signs | Astrology Times",
      description: "Free daily horoscope for all 12 zodiac signs in Hindi and English. Love, career, health predictions with remedies and lucky elements.",
    },
    kundli: {
      title: "Free Kundli Generator | AI-Powered Birth Chart | Astrology Times",
      description: "Generate your free Kundli online. AI-powered Vedic birth chart analysis with planetary positions, dasha, and personalized predictions.",
    },
    panchang: {
      title: "Today's Panchang | Tithi, Nakshatra, Muhurat | Astrology Times",
      description: "Check today's Panchang — Tithi, Nakshatra, Yoga, Karana, Rahukaal, Shubh Muhurat. Accurate Vedic Panchang updated daily.",
    },
    blog: {
      title: "Astrology & Vastu Blog | Tips, Remedies & Insights | Astrology Times",
      description: "Read articles on Vedic astrology, Vastu tips, planetary transits, remedies, and spiritual guidance by Surendra Kumar Patawari.",
    },
    about: {
      title: "About Surendra Kumar Patawari | 17+ Years Vedic Astrologer | Astrology Times",
      description: "Learn about Surendra Kumar Patawari — certified Vedic astrologer and Vastu consultant with 17+ years of experience. 5000+ happy clients.",
    },
    contact: {
      title: "Contact Us | Astrology Times",
      description: "Contact Astrology Times for astrology and Vastu consultations. WhatsApp, email, or contact form. Hyderabad, India.",
    },
    disclaimer: {
      title: "Disclaimer | Astrology Times",
      description: "Legal disclaimer for Astrology Times astrology and Vastu consultation services.",
    },
    terms: {
      title: "Terms & Conditions | Astrology Times",
      description: "Terms and conditions for using Astrology Times services including refund policy and session guidelines.",
    },
    privacy: {
      title: "Privacy Policy | Astrology Times",
      description: "Privacy policy for Astrology Times. How we collect, use, and protect your personal and birth data.",
    },
  },
};
